import { useState, useEffect } from 'react';
import { collection, getDocs, query, doc, setDoc, updateDoc, getDoc, where } from 'firebase/firestore';
import { db } from '../../firebaseconfig';
import Swal from 'sweetalert2';

const useBudgetManagement = (selectedArea, posts) => {
  const [budgets, setBudgets] = useState({});

  const fetchBudgets = async () => {
    try {
      const budgetsQuery = query(collection(db, 'budgets'));
      const querySnapshot = await getDocs(budgetsQuery);
      const budgetsData = {};
      querySnapshot.forEach(doc => {
        budgetsData[doc.id.toLowerCase()] = doc.data().amount;
      });
      setBudgets(budgetsData);
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Error al obtener presupuestos: ' + error.message,
      });
    }
  };

  useEffect(() => {
    fetchBudgets();
  }, []);

  const calculateBudgetUsage = (area) => {
    const totalBudget = budgets[area.toLowerCase()] || 0;
    const totalCost = posts.reduce((sum, post) => sum + parseFloat(post.costo || 0), 0);
    const remaining = totalBudget - totalCost;
    const isExceeded = remaining < 0;

    return { 
      totalCost, 
      budget: totalBudget, 
      remaining, 
      isExceeded, 
      amount: totalBudget
    };
  };

  const updateUsedBudget = async (area, usedAmount) => {
    try {
      const budgetRef = doc(db, 'budgets', area.toLowerCase());
      
      const docSnap = await getDoc(budgetRef);
      
      if (!docSnap.exists()) {
        await setDoc(budgetRef, { amount: budgets[area.toLowerCase()] || 0, used: usedAmount, type: 'area' });
        console.log(`Created new budget document for ${area}`);
      } else {
        await updateDoc(budgetRef, { used: usedAmount });
      }
      
      // Update usedarea for the area
      await updateUsedAreaBudget(area);

    } catch (error) {
      console.error('Error updating used budget:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Error al actualizar el presupuesto utilizado: ' + error.message,
      });
    }
  };

  const updateUsedAreaBudget = async (area) => {
    try {
      const areaRef = doc(db, 'budgets', area.toLowerCase());
      const projectsQuery = query(collection(db, area.toLowerCase()));
      const projectsSnapshot = await getDocs(projectsQuery);

      let totalUsed = 0;
      projectsSnapshot.forEach(doc => {
        const projectData = doc.data();
        if (projectData.obra && projectData.costo) {
          totalUsed += parseFloat(projectData.costo) || 0;
        }
      });

      await updateDoc(areaRef, { usedarea: totalUsed });
      console.log(`Updated usedarea for ${area}: ${totalUsed}`);
    } catch (error) {
      console.error('Error updating usedarea:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Error al actualizar el presupuesto utilizado del área: ' + error.message,
      });
    }
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: 'ARS',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  };

  return {
    budgets,
    calculateBudgetUsage,
    formatCurrency,
    updateUsedBudget,
  };
};

export default useBudgetManagement;

